import * as yup from "yup";

export const dealerInfoValidator = yup.object({
  name: yup.string(),
  phone_number: yup.string(),
  email_address: yup.string(),
  address: yup.string(),
  id_dealer: yup.string(),
});
